import { notEmpty, type SourceReaderFunction } from '@festina-life/core'
import * as Yup from 'yup'

import type { translations } from '../../../../translations/translations'
import {
  type AnyDecimalVFrame,
  type AnyIntegerVFrame,
  type AnyMoneyDecimalVFrame,
  isRangeVFrame,
} from './types'

export const doubleValidation = (
  frame: AnyIntegerVFrame | AnyDecimalVFrame | AnyMoneyDecimalVFrame,
  translate: SourceReaderFunction<(typeof translations)['en-GB']>,
) => {
  let yupDouble = Yup.number()

  const [min, max] = isRangeVFrame(frame)
    ? [frame.min, frame.max]
    : [undefined, undefined]

  const minMaxMessage =
    notEmpty(min) && notEmpty(max)
      ? translate('validation.between', {
          max,
          min,
        })
      : undefined

  if (notEmpty(min)) {
    yupDouble = yupDouble.min(
      min,
      minMaxMessage ??
        translate('validation.min', {
          min,
        }),
    )
  }

  if (notEmpty(max)) {
    yupDouble = yupDouble.max(
      max,
      minMaxMessage ??
        translate('validation.max', {
          max,
        }),
    )
  }

  return yupDouble
}
